/* eslint-disable jsx-a11y/anchor-is-valid */
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { LoginRegisterDialog } from "../../modules/auth/components/LoginRegisterDialog";
import { LoginTab } from "../../modules/auth/enum/LoginTab";
import { Hit33LandingPage } from "../../modules/landingPage/Hit33LandingPage";

const AuthWrapper = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/login"
          element={<LoginRegisterDialog initialTab={LoginTab.LOGIN} />}
        />
        <Route
          path="/credential/:credential"
          element={<LoginRegisterDialog initialTab={LoginTab.LOGIN} />}
        />

        <Route
          path="/register"
          element={
            <LoginRegisterDialog initialTab={LoginTab.REGISTER_OPTION} />
          }
        />
        <Route
          path="/register/:refferalCode"
          element={
            <LoginRegisterDialog initialTab={LoginTab.REGISTER_OPTION} />
          }
        />

        <Route
          index
          element={
            process.env.REACT_APP_SHORT_NAME === "HIT33" ? (
              <Hit33LandingPage />
            ) : (
              <LoginRegisterDialog />
            )
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to={process.env.REACT_APP_SHORT_NAME === "HIT33" ? "" : "/login"}
            />
          }
        />
        <Route
          path="/loginchoose"
          element={<LoginRegisterDialog initialTab={LoginTab.LOGIN_CHOOSE} />}
        />
      </Route>

      <Route element={<Outlet />}></Route>
    </Routes>
  );
};

export { AuthWrapper };
